import { getNearIcon } from '~src/components/layoutIcon/Icon';
const icons: { [tokenId: string]: string } = {
  'a663b02cf0a4b149d2ad41910cb81e23e1c41c32.factory.bridge.near': 'https://assets.ref.finance/images/sFRAX_coin.svg',
  '853d955acef822db058eb8505911ed77f175b99e.factory.bridge.near': 'https://assets.ref.finance/images/FRAX_coin.svg',
  'wrap.near': getNearIcon()
};

export default icons;
